import { useParams } from 'react-router-dom';
import { AlertPage } from '@/features/market-surveillance/alert-page';

const MarketSurveillanceAlertPage = () => {
  const { alertId = '' } = useParams();
  // key resets tab/activation state when navigating between sibling alerts (related tab)
  return <AlertPage alertId={alertId} key={alertId} />;
};
MarketSurveillanceAlertPage.displayName = 'MarketSurveillanceAlertPage';

export default MarketSurveillanceAlertPage;
